<div class="page">
  <div class="card fade-up">

    <div class="hud-title">PIXEL STARSHIPS</div>
    <div class="hud-subtitle">Select Pilot</div>

    <div class="error-msg" *ngIf="error">{{ error }}</div>

    <div class="account-list" *ngIf="accounts.length > 0; else empty">
      <button
        class="account-card"
        *ngFor="let account of accounts; let i = index"
        [style.animation-delay]="i * 60 + 'ms'"
        (click)="select(account)"
        [disabled]="!!loadingId"
        [class.is-loading]="loadingId === account.userId"
      >
        <div class="account-avatar">{{ account.name[0] | uppercase }}</div>
        <div class="account-info">
          <span class="account-name">{{ account.name }}</span>
          <span class="account-meta">
            Ship Lv {{ account.shipLevel || '—' }}
            <ng-container *ngIf="account.trophies || account.trophies === '0'"> &nbsp;·&nbsp; 🏆 {{ account.trophies || '0' }}</ng-container>
            <ng-container *ngIf="account.fleetName"> &nbsp;·&nbsp; {{ account.fleetName }}</ng-container>
          </span>
          <span class="account-meta">{{ account.lastLogin | date:'MMM d, y' }}</span>
        </div>
        <span class="loading-dot" *ngIf="loadingId === account.userId">
          <span class="spinner"></span>
        </span>
        <button
          class="remove-btn"
          *ngIf="loadingId !== account.userId"
          (click)="remove(account, $event)"
          title="Remove account"
          [disabled]="!!loadingId"
        >✕</button>
      </button>
    </div>

    <ng-template #empty>
      <p class="empty-state">No saved accounts yet.<br>Add one below to get started.</p>
    </ng-template>

    <div class="divider">or</div>

    <button class="btn btn-ghost" (click)="addAccount()" [disabled]="!!loadingId">
      + Add Account
    </button>

  </div>
</div>
